import { Card, Title, Text, Badge } from '@tremor/react';
import type { PartHeader as PartHeaderData } from '../api/types';
import { t } from '../lib/i18n';

export default function PartHeader({ header }: { header: PartHeaderData }) {
  const hasSubstitute = header.ssline && header.sspart;
  const hasAlt = header.altl1 && header.altp1;
  return (
    <Card>
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="text-xs text-tremor-content uppercase tracking-wide">
            {header.line} · {header.part}
          </div>
          <Title>{header.pdesc}</Title>
          <div className="mt-3 grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
            {header.addl_desc && (
              <div className="col-span-2">
                <b>{t.part.header.addlDesc}:</b> {header.addl_desc}
              </div>
            )}
            {header.type && (
              <div><b>{t.part.header.type}:</b> {header.type}</div>
            )}
            {header.u_of_ms && (
              <div><b>{t.part.header.uom}:</b> {header.u_of_ms}</div>
            )}
          </div>
        </div>
        <div className="flex flex-col items-end gap-1">
          {hasSubstitute && (
            <Badge color="amber">
              {t.part.header.sustituyePor}: {header.ssline} {header.sspart}
            </Badge>
          )}
          {hasAlt && (
            <Text className="text-xs text-tremor-content">
              {t.part.header.altPart}: {header.altl1} {header.altp1}
            </Text>
          )}
        </div>
      </div>
    </Card>
  );
}
